/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AccessStatus = typeof AccessStatus[keyof typeof AccessStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
